export function formatNumberToVisible(numberIn: number | string) {
    return String(numberIn)
        .match(/.{1,3}/g)
        ?.join(".");
}
